module.exports = __webpack_public_path__ + "img/pg4-article4-text1.bb1afc44.png";